module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-action-4311d16e.svg";